import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { handleImageDialogClose } from '../../../../../common/properties/formFunctions';

const ImageLimitErrorDialog = ({ component, imageLimitExceeded }) => {
  const uploadImageErrorActions = [
    <FlatButton
      label="Halda áfram" labelStyle={{ color: '#222222' }}
      onTouchTap={() => handleImageDialogClose(component)}
    />,
  ];

  return (
    <Dialog
      title="Villa við það að hlaða inn mynd" actions={uploadImageErrorActions}
      modal={false} open={imageLimitExceeded}
      onRequestClose={() => handleImageDialogClose(component)}
    >
      Þú mátt aðeins hlaða inn 15 myndum af hverri eign!
    </Dialog>
  );
};

ImageLimitErrorDialog.propTypes = {
  component: React.PropTypes.any.isRequired,
  imageLimitExceeded: React.PropTypes.bool.isRequired,
};

export default ImageLimitErrorDialog;



// WEBPACK FOOTER //
// ./src/browser/app/components/Dialogs/ImageLimitErrorDialog/ImageLimitErrorDialog.js